
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/shiva/story-of-nayanmars",
      function () {
        return require("private-next-pages/mahashivratri/shiva/story-of-nayanmars/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/shiva/story-of-nayanmars"])
      });
    }
  